<template>
  <div class="layout">
    <download-file :isShowDownloadIcon="true" title="绩效结果指引.pdf" uatId="1667ae80bea558f710c63b849bb8d90e" proId="1667ff7b8f44c2985f8058a4c6e99b58"></download-file>
    <m-assembly-table ref="pageForm"
                    :formData="formData"
                    :data="tableData"
                    :columns="tableColumns"
                    :tableButtons="tableButtons"
                    :settings="settings"
                    :loading="loading"
                    :total="settings.total"
                    @onSubmit="onSubmit"
                    @onPageSizeChange="onPageSizeChange"
                    @onCurrentPageChange="onPageChange"
    ></m-assembly-table>
  </div>
</template>
<script>
  import axios from 'axios';
  import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
  import httpservice from '../../../../utils/http';
  import {formatDateTime} from '@/utils/datetime-format.js';

  export default {
    name: 'PerformanceQueryView',
    components: {mAssemblyTable},
    computed: {
        /* 是否海外系统 */
        isInt() {
            return !this.$route.query.lang;
        },
    },
    data() {
      return {
        currLang: this.$i18n.locale,
        buCode: '',
        buVal: '',
        orgVal: '',
        vendorId: null,
        vendorCode: null,
        loading: false,
        queryParam: '',
        settings: {
          needPager: true,
          showElevator: true,
          showSizer: true,
          pageSizeOpts: [10, 30, 50, 80],
          needSearch: true,
          needValidation: true,
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        formData: {
          row: 7,
          items: [
            {
              title: this.$t('performanceQueryView.businessUnit'), // 事业部
              value: '',
              field: 'buCode',
              disabled: false,
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              methods: {
                change: () => {
                  console.log('this.formData.items[0].value:', this.formData.items[0].value);
                  this.buVal = this.formData.items[0].value;
                }
              },
              options: {
                multiple: false,
                values: []
              },
              type: 'select'
            },
            {
              title: this.$t('performanceQueryView.organization'), // 库存组织
              value: '',
              field: 'orgCode',
              disabled: false,
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              methods: {
                change: () => {
                  this.orgVal = this.formData.items[1].value;
                }
              },
              options: {
                multiple: false,
                values: []
              },
              type: 'select'
            },
            {
              title: this.$t('performanceQueryView.performanceMouth'), // 绩效月份
              field: 'perfMonth',
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              methods: {},
              options: {
                type: 'month',
                format: 'yyyy-MM'
              },
              type: 'datePicker',
              style: 'width:100%'
            },
            {
              title: this.$t('performanceQueryView.category'), // 采购分类
              value: '',
              field: 'categoryNameConcat',
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              methods: {
                changed: () => {}
              },
              options: {
                rows: 1
              },
              type: 'text'
            }
          ]
        },
        // resultSource: {total: 0, list: []},
        // result: {},
        tableData: [],
        orgResult: [],
        orgBuss: [],
        tableColumns: {
          showCheckbox: false,
          showButtons: false,
          columns: [
            {
              title: this.$t('performanceQueryView.performanceMouth'), // 绩效月份
              key: 'perfMonth',
              align: 'center',
              width: 90 // 60
            },
            {
              title: this.$t('performanceQueryView.businessUnit'), // 事业部
              key: 'buName',
              minWidth: 180,
              align: 'left'
              // render: (h, params) => {
              //   return h('span', params.row.buname.split('_')[2]);
              // }
            },
            {
              title: this.$t('performanceQueryView.organization'), // 库存组织
              key: 'organizationName',
              align: 'left',
              minWidth: 220,
              render: (h, params) => {
                if (params.row.organizationName) {
                  return h('Tooltip', {
                    props: {
                      content: params.row.organizationName.split('INV_')[1],
                      placement: 'top'
                    },
                    class: 'm-tooltip-overflow'
                  }, params.row.organizationName.split('INV_')[1]);
                }
              }
            },
            {
              title: this.$t('performanceQueryView.category'), // 采购分类
              key: 'categoryNameConcat',
              align: 'left',
              toolTips: true,
              minWidth: 160 // 100
            },
            {
              title: this.$t('performanceQueryView.categoryCode'), // 小类编码
              key: 'categoryCode',
              align: 'center',
              minWidth: 110 // 100
            },
            {
              title: this.$t('performanceQueryView.numOfCategorySuppliers'), // 小类供应商数量
              key: 'vendorCount',
              align: 'right',
              width: 130 // 70
            },
            {
              title: this.$t('performanceQueryView.compPerformanceScore'), // 综合绩效得分
              key: 'compositeScore',
              align: 'center',
              minWidth: 125 // 60
            },
            {
              title: this.$t('performanceQueryView.compPerformanceRanking'), // 综合绩效排名
              key: 'compositeRank',
              align: 'center',
              minWidth: 125 // 60
            },
            {
              title: this.$t('performanceQueryView.costPerformanceScore'), // 成本绩效得分
              key: 'costScore',
              align: 'center',
              minWidth: 115 // 60
            },
            {
              title: this.$t('performanceQueryView.qualityPerformanceScore'), // 品质绩效得分
              key: 'qualityScore',
              align: 'center',
              minWidth: 130 // 60
            },
            {
              title: this.$t('performanceQueryView.qualityPerformanceRanking'), // 品质绩效排名
              key: 'qualityRank',
              align: 'center',
              minWidth: 130 // 60
            },
            {
              title: this.$t('performanceQueryView.businessPerformanceScore'), // 业务绩效得分
              key: 'businessScore',
              align: 'center',
              minWidth: 140 // 60
            },
            {
              title: this.$t('performanceQueryView.businessPerformanceRanking'), // 业务绩效排名
              key: 'businessRank',
              align: 'center',
              minWidth: 140 // 60
            },
            {
              title: this.$t('performanceQueryView.scoreDetails'), // 指标得分明细
              key: 'fixedRight1',
              fixed: 'right',
              align: 'center',
              minWidth: 100, // 60
              render: (h, params) => {
                return h('a', {
                  style: {
                    color: 'gray'
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: '/performance/performanceQueryDetail',
                        query: {
                          row: JSON.stringify(params.row)
                        }
                      });
                    }
                  }
                }, [
                    h('Icon', {
                      props: {
                        type: 'android-list',
                        size: '24'
                      }
                    }, '')
                ]);
              }
            },
            {
              title: this.$t('performanceQueryView.performanceTrendView'), // 绩效趋势查看
              key: 'fixedRight2',
              fixed: 'right',
              align: 'center',
              minWidth: 90, // 60
              render: (h, params) => {
                return h('a', {
                  style: {
                    color: 'gray'
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: '/performance/performanceQueryTrend',
                        query: {
                          row: JSON.stringify(params.row)
                        }
                      });
                    }
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'android-list',
                      size: '24'
                    }
                  }, '')
                ]);
              }
            },
            {
              title: this.$t('performanceQueryView.performanceDemeritPoints'), // 绩效扣分查询
              key: 'fixedRight3',
              fixed: 'right',
              align: 'center',
              minWidth: 140, // 60
              render: (h, params) => {
                return h('a', {
                  style: {
                    color: 'gray'
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: '/performance/performanceQueryPoints',
                        query: {
                          row: JSON.stringify(params.row)
                        }
                      });
                    }
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'android-list',
                      size: '24'
                    }
                  }, '')
                ]);
              }
            }
          ]
        },
        tableButtons: {
          customButtons: [
            {
              name: 'btn-export',
              icon: 'archive',
              label: this.$t('common.export'),
              click: (button) => {
                this.exportExcel(button);
              }
            }
          ]
        }
      };
    },
    watch: {
      // 'result': function () {
      //   if (this.result.success === true) {
      //     this.resultSource = this.result.data;
      //   } else {
      //     this.$Modal.error({
      //       title: this.$t('common.warn'),
      //       content: this.result.msg
      //     });
      //   }
      //   this.loading = false;
      // },
      'orgResult': function () {
        this.formData.items.map((item) => {
          if (item.field === 'orgCode') {
            item.options.values = this.orgResult;
          }
        });
        // this.formData.items[1].options.values = this.orgResult;
      },
      'orgBuss': function () {
        this.formData.items.map((item) => {
          if (item.field === 'buCode') {
            item.options.values = this.orgBuss;
          }
        });
      },
      'buVal': function (newVal) {
        console.log('~~~buVal:', this.buVal);
        if (!this.buVal) { // 事业部为空的时候，库存组织可以选择全部组织
          this.formData.items.map((item) => {
            if (item.field === 'orgCode') {
              item.options.values = this.orgResult;
            }
          });
        }
        if (newVal) {
          let selectOrg = [];
          this.orgResult.forEach((item) => {
            if (item.bussOrg === this.buVal) {
              selectOrg.push(item);
            }
          });
          this.formData.items.map((item) => {
            if (item.field === 'orgCode') {
              item.options.values = selectOrg; // 级联当前事业部下的组织
            }
          });
        }
      },
      'orgVal': function (newVal) {
        console.log('~~~orgVal2:', this.orgVal);
        if (newVal) {
          let _bussOrg = '';
          this.orgResult.forEach((item) => {
            if (item.value === this.orgVal) {
              _bussOrg = item.bussOrg;
            }
          });
          let val2 = '';
          this.orgBuss.forEach((item) => {
            if (item.value === _bussOrg) {
              val2 = item.value;
            }
          });
          let buVal = '';
          this.formData.items.forEach((item) => {
            if (item.field === 'buCode') {
              buVal = item.value;
            }
          });
          if (val2 !== buVal) {
            this.formData.items.map((item) => {
              if (item.field === 'buCode') {
                item.value = val2; // 事业部需要与当前选择组织级联
              }
            });
          }
        }
      },
    },
    methods: {
      onSubmit(page, pageSize, condition) {
        this.condition = condition;
        this.settings.currentPage = page;
        this.settings.pageSize = pageSize;
        this.onSearch();
      },
      onSearch() {
        let params = this.condition;
        this.formData.items.map((item) => {
          if (item.field === 'buCode' && item.value) {
            let buName = this.orgBuss.find(innerItem => innerItem.value === item.value).label;
            params.buCode = buName.split('_')[1];
          }
        });
        params.perfMonth = params.perfMonth ? formatDateTime(new Date(params.perfMonth), 'yyyyMM') : '';
        params.language = this.currLang;
        params.vendorCode = this.vendorCode;
        params.pageNum = this.settings.currentPage;
        params.pageSize = this.settings.pageSize;
        this.loading = true;
        this.tableData = [];
        axios.post('/srmperf/gsc/composite/queryCompositeDetail', params).then(res => {
            try {
                this.loading = false;
                const { code, datas, msg: content } = res.data.data;
                if (code === '1') {
                    this.settings.total = datas.total;
                    this.tableData = datas.list;
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content,
                    });
                }
            } catch (err) {
                console.log('err:', err);
            }
        }).catch(() => {
            this.loading = false;
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('common.error1')
            });
        });
      },
      onPageChange(page) {
        this.settings.currentPage = page;
        this.onSearch();
      },
      onPageSizeChange(pageSize) {
        this.settings.pageSize = pageSize;
        this.onSearch();
      },
      getOrganizationName() {
        return new Promise((resolve) => {
          httpservice.get('/gscint/vendor/getAllInvList?SITE=Y&ASL=N').then(res => {
            let { datas } = res.data.data;
            if (datas) {
                datas.forEach((item) => {
                    item.bussOrg = item.buId;
                    item.value = item.organizationCode;
                    item.label = item.organizationName;
                });
                resolve(datas || []);
            }
          });
        }).catch(err => {
          console.log('err:', err);
        });
      },
      getBussOrg() {
        return new Promise((resolve) => {
          httpservice.get(this.isInt ? '/gscint/vendor/getOverSeaBuList?SITE=Y&ASL=N' : '/gscint/vendor/getAllBuList').then(res => {
            let { datas } = res.data.data;
            resolve(datas || []);
          });
        }).catch(err => {
          console.log('err:', err);
        });
      },
      /** 深拷贝 */
      objDeepCopy: function (source) {
          var sourceCopy = source instanceof Array ? [] : {};
          for (var item in source) {
              if (typeof source[item] === 'object') {
                  if (source[item] === null) {
                      sourceCopy[item] = null;
                  } else {
                      sourceCopy[item] = this.objDeepCopy(source[item]);
                  }
              } else {
                  sourceCopy[item] = source[item];
              }
          }
          return sourceCopy;
      },
      exportExcel(button) {
        this.$set(button, 'loading', true);
        let params = {};
        this.formData.items.map((item) => {
            if (item.field === 'perfMonth') {
              params[item.field] = item.value ? formatDateTime(new Date(item.value), 'yyyyMM') : '';
            } else {
                params[item.field] = item.value;
                if (item.field === 'buCode' && item.value) {
                  let buName = this.orgBuss.find(innerItem => innerItem.value === item.value).label;
                  params.buCode = buName.split('_')[1];
                }
            }
        });
        params.language = this.currLang;
        params.vendorCode = this.vendorCode;
        params.pageNum = this.settings.currentPage;
        params.pageSize = 999999;

        var a = document.createElement('a');
        a.href = '/srmperf/gsc/composite/exportCompositeDetail?paraJson=' + encodeURI(JSON.stringify(params));
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => {
          this.$set(button, 'loading', false);
        }, 4000);
      }
    },
    mounted() {
      this.vendorId = JSON.parse(localStorage.getItem('supplierInfo')).vendorId;
      this.vendorCode = JSON.parse(localStorage.getItem('supplierInfo')).vendorCode;
      let totday = new Date();
      let lastMouth = totday.getMonth() - 1;
      totday.setMonth(lastMouth);
      this.formData.items[2].value = totday;
      Promise.all([this.getBussOrg(), this.getOrganizationName()]).then((rep) => {
        console.log('Promise_result::', rep);
        this.orgResult = rep[1];
        rep[0].forEach(item => {
          this.orgBuss.push({
              label: item.buName,
              value: item.buId,
              organizationId: item.organizationId
          });
        });
      });
    }
  };
</script>

<style scoped lang='less'>
</style>
